//import '../ConfigSettings.js';
declare var Config: any;

export class Global {
  public static urlapi = localStorage.getItem('Vista_urlapi') != null ? localStorage.getItem('Vista_urlapi') : '';
  // public static get urlapi(): string {
  //   return localStorage.getItem('Vista_urlapi');
  // }
  public static BASE_URL = Global.urlapi.toString().endsWith('/') ? Global.urlapi.toString() : Global.urlapi.toString().concat('');

  public static BASE_API_URL = Global.BASE_URL.concat('api/');
  // parametre
  public static BASE_API_Seasonality = Global.BASE_API_URL.concat('SeasonalityApplicationApi/');
  public static BASE_API_DailyRos = Global.BASE_API_URL.concat('DailyROSApi/');
  public static BASE_API_Duties = Global.BASE_API_URL.concat('DutiesApi/');
  public static BASE_API_Spds = Global.BASE_API_URL.concat('SPDApi/');
  public static BASE_API_Outliers = Global.BASE_API_URL.concat('OutliersApi/');
  public static BASE_API_CompetitorOutliers = Global.BASE_API_URL.concat('CompetitorOutliersApi/');
  public static BASE_API_VAT = Global.BASE_API_URL.concat('VATApi/');
  public static BASE_API_RetailerMargin = Global.BASE_API_URL.concat('RetailerMarginApi/');
  public static BASE_API_CostLiter = Global.BASE_API_URL.concat('AdditionalCostLiterApi/');
  public static BASE_API_TaxLiter = Global.BASE_API_URL.concat('AdditionalTaxLiterApi/');
  public static BASE_API_Handlings = Global.BASE_API_URL.concat('HandlingsApi/');
  public static BASE_API_PromotedVolume = Global.BASE_API_URL.concat('PromotedVolumeRatiosApi/');
  public static BASE_API_GetMultiplesByMarketCo = Global.BASE_API_URL.concat('PromotedVolumeRatiosApi/GetMultiplesByMarketCo');
  public static BASE_API_PromoMultipleAPi = Global.BASE_API_URL.concat('MultiplesApi/');
  public static BASE_API_PromoDepth = Global.BASE_API_URL.concat('PromoDepthRangeApi/');
  public static BASE_API_PromoMulptiple = Global.BASE_API_URL.concat('PromoMultipleRangeApi/');
  public static BASE_API_PromoRetailFundingRange = Global.BASE_API_URL.concat('PromoRetailFundingRangeApi/');
  public static BASE_API_EposFirstDay = Global.BASE_API_URL.concat('EposFirstDayofWeekApi/');
  public static BASE_API_PromoManagement = Global.BASE_API_URL.concat('PromoEventManagementApi/');
  public static BASE_API_CompetitorPromoManagement = Global.BASE_API_URL.concat('CompetitorPromoEventManagementApi/');
  public static BASE_API_MarketCompanyDisplayUnit = Global.BASE_API_URL.concat('MarketCompanyDisplayUnitApi/');
  public static BASE_API_ParamsProc = Global.BASE_API_URL.concat('ParamsProcApi/');
  public static BASE_API_ShopperOfferGroup = Global.BASE_API_URL.concat('ShopperOfferGroupApi/');
  public static BASE_API_ShopperOfferGroupShopperOffer = Global.BASE_API_URL.concat('ShopperOfferGroupShopperOfferApi/');
  public static BASE_API_RegionnalBanner = Global.BASE_API_URL.concat('PromoEventCustomerLevelApi/');
  public static BASE_API_CustomerApi = Global.BASE_API_URL.concat('CustomerApi/');
  public static BASE_API_CalendarEvents = Global.BASE_API_URL.concat('CalendarEventsApi/');
  public static BASE_API_CompetitiveSet = Global.BASE_API_URL.concat('CompetitiveSetApi/');
  public static BASE_API_RSP = Global.BASE_API_URL.concat('RSPApi/');
  public static BASE_API_PromoScopeController = Global.BASE_API_URL.concat('PromoScope/');
  public static BASE_API_PromoScopeCompetitorController = Global.BASE_API_URL.concat('PromoScopeCompetitor/');
  public static BASE_API_PromoSpendController = Global.BASE_API_URL.concat('PromoSpendApi/');
  public static BASE_API_PromoDetectionTHresholdController = Global.BASE_API_URL.concat('PromoDetectionThresholdApi/');
  public static BASE_API_RFPDController = Global.BASE_API_URL.concat('RFPDApi/');
  public static BASE_API_CompetitorRSP = Global.BASE_API_URL.concat('RSPCompetitorApi/');




  // Data
  public static BASE_API_Banner_Base = Global.BASE_API_URL.concat('BannersApi/');
  public static BASE_API_Banner_Get = Global.BASE_API_URL.concat('BannersApi/Get');
  public static BASE_API_Banner = Global.BASE_API_URL.concat('BannersApi/');
  public static BASE_API_Banner_By_MarkeCo = Global.BASE_API_URL.concat('BannersApi/GetByUserMakerCo');
  public static BASE_API_Banner_By_MarkeCoRG = Global.BASE_API_URL.concat('BannersApi/GetByUserMakerCoRG');
  public static BASE_API_Products_Base = Global.BASE_API_URL.concat('ProductsApi/');
  public static BASE_API_Products = Global.BASE_API_URL.concat('ProductsApi/GetAll/');
  public static BASE_API_GetSizeByBrandQuality = Global.BASE_API_URL.concat('ProductsApi/GetSizeByBrandQuality');
  public static BASE_API_GetSizeByBrandQualityCompetitor = Global.BASE_API_URL.concat('ProductCompetitorApi/GetSizeByBrandQualityCompetitor/');
  public static BASE_API_Cogs_Base = Global.BASE_API_URL.concat('COGSApi/');
  public static BASE_API_Cogs = Global.BASE_API_URL.concat('COGSApi/GetAll/');
  public static BASE_API_Epos = Global.BASE_API_URL.concat('EPOSApi/GetAll/');
  public static BASE_API_Epos_Params = Global.BASE_API_URL.concat('EPOSApi/Get');
  public static BASE_API_EposCompitetor_Params = Global.BASE_API_URL.concat('EPOSCompetitorApi/Get');
  public static BASE_API_PromoInformation = Global.BASE_API_URL.concat('PromoApi/Get/');
  public static BASE_API_PromoQualification = Global.BASE_API_URL.concat('PromoQualificationApi/GetAll/');
  public static BASE_API_Shopper = Global.BASE_API_URL.concat('ShopperOfferApi/Get/');
  public static BASE_API_SellInContract_Base = Global.BASE_API_URL.concat('SellInContractsApi/');
  public static BASE_API_SellInContract = Global.BASE_API_URL.concat('SellInContractsApi/GetAll/');
  public static BASE_API_PromotionApi_Base = Global.BASE_API_URL.concat('PromotionApi/');
  public static BASE_API_DistributorPrice_Base = Global.BASE_API_URL.concat('DistributorPriceApi/');
  //A voir : public static BASE_API_PromotionApi = Global.BASE_API_URL.concat('PromotionApi/GetAll/');
  public static BASE_API_PromotionApi = Global.BASE_API_URL.concat('PromoCompetitorApi/');
  public static BASE_API_ProductCompetitor = Global.BASE_API_URL.concat('ProductCompetitorApi/');
  public static BASE_API_ShopperOfferCompetitor = Global.BASE_API_URL.concat('ShopperOfferCompetitorApi/');
  public static BASE_API_EPOSCompetitorByProduct = Global.BASE_API_URL.concat('EPOSCompetitorByProductApi/GetAll/');
  public static BASE_API_DataExtraction = Global.BASE_API_URL.concat('DataExtraction/');
  public static BASE_API_DataExtractionCompetitor = Global.BASE_API_URL.concat('DataExtractionCompetitor/');
  public static BASE_API_InStoreShopperOffer = Global.BASE_API_URL.concat('InStoreShopperOfferApi/');
  public static BASE_API_StandardRspEnriched = Global.BASE_API_URL.concat('StandardRspEnrichedApi/');
  public static BASE_API_StandardRspEnrichedCompetitor = Global.BASE_API_URL.concat('StandardRspEnrichedCompetitorApi/');
  public static BASE_API_InStoreShopperOfferCompetitor = Global.BASE_API_URL.concat('InStoreShopperOfferCompetitorApi/');


  // User Management
  public static BASE_API_Users = Global.BASE_API_URL.concat('UserManagementApi/');
  public static BASE_API_DataAccess = Global.BASE_API_URL.concat('DataAccessApi/');
  public static BASE_API_WebAppAccess = Global.BASE_API_URL.concat('WebAppAccessApi/');
  public static BASE_API_DashboardAccess = Global.BASE_API_URL.concat('DashboardAccessApi/');
  public static BASE_API_AlertRefresh = Global.BASE_API_URL.concat('AlertDataRefreshApi/');

  //LMF Ratio API
  public static BASE_API_RATIO = Global.BASE_API_URL.concat('RatioApi/');

  //api DAL object
  public static BASE_API_MarketCompanies_Base = Global.BASE_API_URL.concat('MarketCompanyApi/');
  public static BASE_API_MarketCompanies = Global.BASE_API_URL.concat('MarketCompanyApi/GetAll/');
  public static BASE_API_AllMarketCompanies = Global.BASE_API_URL.concat('MarketCompanyApi/GetAll/'); //For Perimeter
  public static BASE_API_ProductCategroy = Global.BASE_API_URL.concat('ProductCategoryApi/GetAll');
  public static BASE_API_SeasonalityCategroy = Global.BASE_API_URL.concat('SeasonalityCategoryApi/');
  public static BASE_API_PeriodicityEpos = Global.BASE_API_URL.concat('PeriodicityEposApi/');
  public static BASE_API_EposExclusionManage = Global.BASE_API_URL.concat('EposExclusionManagementApi/');
  public static BASE_API_BannerNAmes = Global.BASE_API_URL.concat('BannersApi/GetAll/');
  public static BASE_API_ShopperTypes = Global.BASE_API_URL.concat('ShopperTypeApi/GetAll');
  public static BASE_API_BrandQualityBase = Global.BASE_API_URL.concat('BrandQualityApi/');
  public static BASE_API_BrandQualityCompetitorBase = Global.BASE_API_URL.concat('BrandQualityCompetitorApi/');
  public static BASE_API_BrandQuality = Global.BASE_API_URL.concat('BrandQualityApi/GetAll/');
  public static BASE_API_BrandQualityMarketCo = Global.BASE_API_URL.concat('BrandQualityApi/GetByMarketCo');
  public static BASE_API_BrandQualityCompetitorMarketCo = Global.BASE_API_URL.concat('BrandQualityCompetitorApi/');
  public static BASE_API_GenericParametersMethodesApi = Global.BASE_API_URL.concat('GenericParametersMethodesApi/');
  public static BASE_API_PromoType = Global.BASE_API_URL.concat('PromoTypeApi/GetAll/');
  public static BASE_API_Brand = Global.BASE_API_URL.concat('BrandApi/');
  public static BASE_API_BrandCompetitor = Global.BASE_API_URL.concat('BrandCompetitorApi/');
  public static BASE_API_BrandbyMarketCo = Global.BASE_API_URL.concat('BrandApi/GetByMarketCo');
  public static BASE_API_Customer = Global.BASE_API_URL.concat('CustomerApi/');
  public static BASE_API_DutyBaseType = Global.BASE_API_URL.concat('DutyBaseTypeApi/Get/');
  public static BASE_API_PromoStatus = Global.BASE_API_URL.concat('PromoEventStatusApi/Get');
  public static BASE_API_Monitoring = Global.BASE_API_URL.concat('MonitoringApi/Get');
  public static BASE_API_CoherencyTest = Global.BASE_API_URL.concat('CoherencyTestsApi/');
  public static BASE_API_Currency = Global.BASE_API_URL.concat('CurrencyApi/');
  public static BASE_API_DateFormat = Global.BASE_API_URL.concat('DateFormatApi/');
  public static BASE_API_RefEventTypes = Global.BASE_API_URL.concat('RefEventTypeApi/GetAll');
  public static BASE_API_setting = Global.BASE_API_URL.concat('SettingApi/');
  public static BASE_API_BrandQualityByMarketCo = Global.BASE_API_URL.concat('BrandQualityApi/GetBrandQualityByMarketCo');
  public static BASE_API_RoundDepthOption= Global.BASE_API_URL.concat('RoundDepthOptionApi/');
  public static BASE_API_CompetitorEposExclusionManage = Global.BASE_API_URL.concat('CompetitorEposExclusionManagementApi/');
  public static BASE_API_KeyWord = Global.BASE_API_URL.concat('KeyWordsApi/Get/'); 
  public static BASE_API_Entities = Global.BASE_API_URL.concat('EntitiesApi/Get/'); 
  public static BASE_API_HistoryOperations = Global.BASE_API_URL.concat('HistoryOperationApi/'); 

  //public static BASE_API_Multiples = Global.BASE_API_URL.concat('BrandQualityApi/Get/');
  //Column number
  public static ColumnDuties = 14;
  public static ColumnHandlings = 4;
  public static ColumnCalendar = 12;
  public static ColumnEposFistDay = 6;
  public static ColumnMarketCoDisplayUnit = 4;
  public static ColumnDailyRos = 20;
  public static ColumnSeasonalitiesCat = 3;
  public static ColumnProductCategory = 8;
  public static ColumnPeriodicityEpos = 7;
  public static ColumnPromoMultipe = 5;
  public static ColumnShopperOfferGroup = 4;
  public static ColumnPromoDepth = 6;
  public static ColumnPromoRetail = 6;
  public static ColumnPromoMulitpleRange = 6;
  public static ColumnPromoVolumeRatio = 13;
  public static ColumnShopperType = 8;
  public static ColumnCustomerLevel = 5;
  public static ColumnCompetitiveSet = 11;
  public static ColumnEposEM = 13;
  public static ColumnPromoEventManagement = 15;
  public static ColumnRSP = 10;
  public static ColumnRatio = 8;
  public static ColumnPromoScope = 11;
  public static ColumnPromoScopeCompetitor = 11;
  public static ColumnPromoSpend = 12;
  public static ColumnPromoDetctionThreshold = 14;
  public static ColumnRFPD = 9;
  public static ColumnVat = 11;
  public static ColumnAdditionalCostLiter = 11;
  public static ColumnAdditionalTaxLiter = 11;
  public static ColumnSpd = 12;
  public static ColumnRetailerMargin = 11;
  public static ColumnCompetitorPromoEventManagement = 14;




}
